module.exports = __webpack_public_path__ + "img/pontem.6d5e49d8.svg";